import { Icon } from "@iconify/react";
import _ from "lodash";
import { Fragment } from "react/jsx-runtime";
import Markdown from "react-markdown";
import { Copier } from "../../helpers/Copier";

function ThinkingIndicator() {
  return (
    <span className="flex items-center gap-1 text-gray-500 animate-pulse">
      <span>Thinking</span>
      <span className="flex gap-1">
        <span
          className="w-1 h-1 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: "0ms" }}
        ></span>
        <span
          className="w-1 h-1 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: "150ms" }}
        ></span>
        <span
          className="w-1 h-1 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: "300ms" }}
        ></span>
      </span>
    </span>
  );
}

interface Message {
  chat_session_uid: string;
  id?: string;
  content: string;
  role: "user" | "assistant";
  timestamp: Date;
}

type AgentMessageProps = {
  message: Message;
  isGlobalLoading: boolean;
};

export function AgentMessage({ message, isGlobalLoading }: AgentMessageProps) {
  return (
    <div className="AgentMessage grid justify-items-start auto-rows-max">
      <div className="w-full rounded-lg p-2 bg-gray-100 text-gray-800">
        <span className="text-xs opacity-70 mb-1 grid grid-cols-[1fr_auto] bg-gray-200 rounded-lg p-2">
          <span className="flex items-center gap-1">
            <Icon icon="heroicons:cpu-chip" className="w-5 h-5" />
            {_.capitalize(message.role)}
          </span>
          {message.content && <Copier content={message.content} />}
        </span>
        <p className="whitespace-normal [&_li]:list-disc [&_li]:ml-6 p-2">
          {message.content ? (
            <Fragment>
              <Markdown className="[&_h2]:text-xl! [&_h3]:text-lg! [&_h4]:text-base! [&_h5]:text-base! [&_h6]:text-base!">
                {message.content}
              </Markdown>
              {isGlobalLoading && <ThinkingIndicator />}
            </Fragment>
          ) : isGlobalLoading ? (
            <ThinkingIndicator />
          ) : null}
        </p>
        <span className="text-xs opacity-70 mt-1 block text-right font-bold">
          {!!message.content && message.timestamp.toLocaleTimeString()}
        </span>
      </div>
    </div>
  );
}
